module.exports = __webpack_public_path__ + "static/img/list01.ee80ae8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/img/list01.jpg
// module id = 49pp
// module chunks = 1